import {
  ADICIONAR_DADOS_CTE_ENCOMENDA, LIMPAR_DADOS_CTE_ENCOMENDA
} from '../../actions/types'

const initialState = undefined;
const value = {
  rntrc: '',
  naturezaOperacao: {
      label: '',
      value: null
  },
    tipoServicoCte: {
      label: '',
      value: null
  },
  chaveNfe: ''
};

export default function reducerDadosCteEncomenda (state = value, action = initialState) {
    switch (action.type) {
      case ADICIONAR_DADOS_CTE_ENCOMENDA: {
        return action.payload
      }

      case LIMPAR_DADOS_CTE_ENCOMENDA: {
        return value;
      }

      default: {
        return state
      }
    }
}